export enum ETypeSearchItem {
  Drug = 'Medicamento',
  Prescription = 'Prescrição',
  Theme = 'Tema',
  Topic = 'Tópico',
}
